import { VehicleRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * saveVehicleByCustomerAndDepartment - Function that saves on database a new vehicle   
 * /vehicles  
 * method POST  
 * @async-function
 */
const saveVehicleByCustomerAndDepartment = async (token: string, model: VehicleRequestType) => {
    const response = await api.post(
        `/vehicles`, { ...model }, {
        headers: {'Authorization': `Bearer ${token}` }
    });
    return response;
};

export default saveVehicleByCustomerAndDepartment;